import React, { useState, useContext, useReducer, useCallback } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import CustomSelect from '@material-ui/core/Select';
import axios from 'api/axios';
import { Button } from '@material-ui/core';
import { store, initialState, reducer, actions } from './reducer';
import ProgressiveButton from 'components/Button/ProgressiveButton';
import { useParams } from 'react-router-dom';
import { store as mainStore } from '../../../../../store';
import { toEN } from 'fns';

const useStyles = makeStyles((theme) => ({
  pelak: {
    height: '56px',
    backgroundImage: 'url(../../../files/img/pelak.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
}));
const alefba = [
  'الف',
  'ب',
  'پ',
  'ت',
  'ث',
  'ج',
  'چ',
  'ح',
  'خ',
  'د',
  'ذ',
  'ر',
  'ز',
  'ژ',
  'س',
  'ش',
  'ص',
  'ض',
  'ط',
  'ظ',
  'ع',
  'غ',
  'ف',
  'ق',
  'ک',
  'گ',
  'ل',
  'م',
  'ن',
  'و',
  'ه',
  'ی',
];

const LicensePlate = ({ driver, onSuccess }) => {
  const { id } = useParams();
  const classes = useStyles();
  const { refresh } = useContext(store);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [bidders, setBidders] = useState([]);
  const driverId = driver._id;
  const { showMessage, showError } = useContext(mainStore);
  const [defaultNumberPlate, setDefaultNumberPlate] = useState({
    cityCode: null,
    firstCode: null,
    alphabetCode: 'د',
    secondCode: null,
  });
  const [loading, setLoading] = useState(false);
  async function handleChangeFleetPlate(e) {
    const { name, value } = e.target;
    setDefaultNumberPlate({
      ...defaultNumberPlate,
      [name]: name !== 'alphabetCode' ? toEN(value) : value,
    });
  }

  function validatePlate(plate) {
    if (Object.values(plate).includes('')) return false;
    if (!plate.cityCode || !plate.firstCode || !plate.secondCode) return false;
    if (toEN(plate.cityCode).length < 2 || toEN(plate.cityCode[0]) === '0')
      return false;
    if (toEN(plate.firstCode).length < 3 || toEN(plate.firstCode[0]) === '0')
      return false;
    if (toEN(plate.secondCode).length < 2 || toEN(plate.secondCode[0]) === '0')
      return false;

    return true;
  }

  async function submitLicenesePlate() {
    const validate = validatePlate(defaultNumberPlate);
    if (!validate) return showError('پلاک را به صورت صحیح وارد کنید.');
    try {
      setLoading(true);
      await axios.put(`/api/v1/admin/driver/${driver.user._id}`, {
        fleetOptions: driver.fleetOptions || '',
        numberPlate: defaultNumberPlate,
      });
      refresh();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid xs={10} md={3}>
        <div className={classes.pelak}>
          <Grid container>
            <Grid item xs={3}>
              <TextField
                inputProps={{
                  maxLength: 2,
                }}
                placeholder={'96'}
                variant="filled"
                color="secondary"
                name="cityCode"
                type="tel"
                value={defaultNumberPlate?.cityCode}
                onChange={handleChangeFleetPlate}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                inputProps={{
                  maxLength: 3,
                }}
                type={'tel'}
                placeholder={'000'}
                variant="filled"
                color="secondary"
                name="firstCode"
                value={defaultNumberPlate?.firstCode}
                onChange={handleChangeFleetPlate}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl variant="filled" fullWidth>
                <InputLabel>حروف</InputLabel>
                <CustomSelect
                  name="alphabetCode"
                  value={defaultNumberPlate?.alphabetCode}
                  onChange={handleChangeFleetPlate}
                >
                  {alefba.map((name) => (
                    <MenuItem name="alphabetCode" key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </CustomSelect>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <TextField
                variant="filled"
                color="secondary"
                name="secondCode"
                placeholder={'00'}
                inputProps={{
                  maxLength: 2,
                }}
                type={'tel'}
                value={defaultNumberPlate?.secondCode}
                onChange={handleChangeFleetPlate}
              />
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item xs={10} md={3}>
        <ProgressiveButton
          onClick={() => submitLicenesePlate()}
          variant="contained"
          color="primary"
          disabled={loading}
          endIcon
        >
          ثبت پلاک
        </ProgressiveButton>
      </Grid>
    </Grid>
  );
};

export default LicensePlate;
